/**
 * House関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { List, Record } from 'immutable'
import LocalDate from '../../domain/type/Date'
import { MealConditionInstance } from '../../domain/model/plan/MealCondition'

const _ReservationState = {
  id: null,
  room_id: null,
  hotel_id: null,
  status: '',
  stay: '',
  key_code: '',
  check_in: null,
  check_out: null,
  first_name: '',
  last_name: '',
  name: '',
  email: '',
  phone_number: '',
  mobile_number: '',
  num_adult: '',
  num_child: '',
  num_infant: '',
  accommodation_fee: '',
  commission: '',
  accommodation_tax: null,
  guest_arrival_time: '',
  site_referer: '',
  reservation_code: '',
  country: '',
  api_message: '',
  guest_comment: null,
  notes: '',
  shared_notes: '',
  checkin_status: '',
  noshow: false,
  arrived_at: '',
  bookid: '',
  is_paid_accommodation_fee: false,
  is_paid_accommodation_tax: false,
  rate_description: '',
  execute_invoice_automation: '',
  form_count: '',
  channel_manager: '',
  plan_code: '',
  plan_name: '',
  meal_condition: '',
  meal_condition_pms: '',
  meal_delivery: ''
}

const ReservationStatusLabels = {
  booked: '通常予約',
  cancelled: 'キャンセル',
  not_a_reservation: '売り止め'
}

class ReservationState extends Record(_ReservationState) {
  mergeModel(model) {
    return this.merge(model)
  }

  mergeModelLocalDate(model) {
    model.check_in = new LocalDate(model.check_in)
    model.check_out = new LocalDate(model.check_out)
    return this.merge(model)
  }

  setStatus(value) {
    if (value === 'not_a_reservation') {
      return this.merge({ status: value, execute_invoice_automation: 'disabled' })
    }

    return this.set('status', value)
  }

  calculateStayingDays() {
    if (!this.check_in || !this.check_out) {
      return null
    }

    let check_in = this.check_in
    let check_out = this.check_out

    check_in.setHours(0, 0, 0, 0)
    check_out.setHours(0, 0, 0, 0)

    const diff = check_out.getTime() - check_in.getTime()

    if (diff < 0) {
      return 0
    }

    return Math.ceil(diff / 86400000)
  }

  checkInDate(format = 'LLL d') {
    const check_in = new LocalDate(this.check_in)
    return check_in.format('LLL d')
  }

  checkOutDate(format = 'LLL d') {
    const check_out = new LocalDate(this.check_out)
    return check_out.format('LLL d')
  }

  getStatusLabel() {
    return ReservationStatusLabels[this.status] || '不明'
  }
  getStatusValueOfBooked() {
    return 'booked'
  }
  getStatusValueOfCancelled() {
    return 'cancelled'
  }
  getStatusValueOfNotReservation() {
    return 'not_a_reservation'
  }
  getStatusLabelOfBooked() {
    return ReservationStatusLabels['booked']
  }
  getStatusLabelOfCancelled() {
    return ReservationStatusLabels['cancelled']
  }
  getStatusLabelOfNotReservation() {
    return ReservationStatusLabels['not_a_reservation']
  }

  getMealCondition() {
    const mealCondition = MealConditionInstance.getLabel(this.meal_condition_pms) || MealConditionInstance.getLabel(this.meal_condition)

    if (mealCondition === 'この客室にはお食事のオプションはありません。') {
      return '食事なし'
    }

    return mealCondition
  }

  getMealConditionValue() {
    return this.meal_condition_pms || this.meal_condition
  }
}

const MonthlyReservationsState = Record({
  today: new Date(),
  date: new Date(),
  reservations: List(),
  event_schedules: List()
})

export { MonthlyReservationsState, ReservationState, ReservationStatusLabels }
